import React, { useState } from 'react';

import {
  Alert,
  Breakpoints,
  CTA,
  Spinner,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
  ThemeProvider,
} from '@vw-marketing/us-components';

import {
  StyledButtonsContainer,
  StyledDeactivateErrorContainer,
  StyledErrorHeaderContainer,
  StyledNameErrorDescriptionContainer,
} from './styles';

interface DeactivateAccountErrorViewProps {
  translationHandler: (key: string) => string;
  isDesktop: boolean;
  fetchAdditionalVehiclesInformation: () => Promise<void>;
  onClose: () => void;
}

export const DeactivateAccountErrorView = ({
  translationHandler,
  isDesktop,
  fetchAdditionalVehiclesInformation,
  onClose,
}: DeactivateAccountErrorViewProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleTryAgain = async () => {
    setIsLoading(true);
    try {
      await fetchAdditionalVehiclesInformation();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme="main">
      <StyledDeactivateErrorContainer>
        <div style={{ margin: 'auto 0' }}>
          <StyledErrorHeaderContainer>
            <Alert />
            <TextCustom
              appearance={TextAppearance.label200}
              style={{
                [Breakpoints.default]: {
                  fontSize: TextSize.TextSize20,
                  fontWeight: TextWeight.regular,
                  color: TextColor.primary,
                  lineHeight: TextLineHeight.TextLineHeight24,
                },
                [Breakpoints.b1920]: {
                  fontSize: TextSize.TextSize24,
                  color: TextColor.primary,
                  lineHeight: TextLineHeight.TextLineHeight28,
                },
              }}
            >
              {translationHandler('accountSettings.deactivate.myvwaccount.subscriptions.error.title')}
            </TextCustom>
          </StyledErrorHeaderContainer>
          <StyledNameErrorDescriptionContainer>
            <TextCustom
              appearance={TextAppearance.copy200}
              style={{
                [Breakpoints.default]: {
                  color: TextColor.secondary,
                  fontSize: TextSize.TextSize16,
                  fontWeight: TextWeight.regular,
                  lineHeight: TextLineHeight.TextLineHeight24,
                  textAlign: TextAlignment.center,
                },
                [Breakpoints.b1920]: {
                  fontSize: TextSize.TextSize20,
                  lineHeight: TextLineHeight.TextLineHeight32,
                },
              }}
            >
              {translationHandler('accountSettings.deactivate.myvwaccount.subscriptions.error.description')}
            </TextCustom>
          </StyledNameErrorDescriptionContainer>
        </div>
        <StyledButtonsContainer>
          <CTA
            disabled={isLoading}
            emphasis='secondary'
            onClick={onClose}
            stretchContent={!isDesktop}
            tag='button'
          >
            {translationHandler('accountSettings.deactivate.myvwaccount.goBack.label')}
          </CTA>
          <CTA
            disabled={isLoading}
            onClick={handleTryAgain}
            stretchContent={!isDesktop}
            tag='button'
            icon={isLoading ? <Spinner /> : undefined}
          >
            {isLoading ? '' : translationHandler('accountSettings.deactivate.myvwaccount.tryAgain.label')}
          </CTA>
        </StyledButtonsContainer>
      </StyledDeactivateErrorContainer>
    </ThemeProvider>
  );
};
